// How the stage fits and zooms the art, apart from the component so it is tested without it.
// The frame's padding in styles.scss: --gap-3 sides (a carousel's are 54px, its 34px page
// arrow 8px from the art and 12px from the edge), --gap-2 top, 76px bottom (the floating
// inspector takes the stage's last 64px). The fit leaves the same space.
const PAD = { x: 24, pager: 54, top: 16, bottom: 76 };
const ZOOM_STEPS = [0.1, 0.25, 0.33, 0.5, 0.67, 0.75, 1, 1.25, 1.5, 2, 3];
const ZOOM_RANGE = [ZOOM_STEPS[0], ZOOM_STEPS[ZOOM_STEPS.length - 1]];
// Pinch (and Ctrl + wheel) zoom is continuous: each event scales by e^(-delta·k), with the
// delta clamped so a mouse wheel notch is a gentle ~13% and a trackpad pinch glides.
const PINCH_RATE = 0.0035;
const PINCH_MAX_DELTA = 40;
// Below this stage width (a phone's) a carousel's page arrows sit over the art's edges, so
// the art keeps its size; the Studio's art panel is wider.
const PAGER_BESIDE_MIN_WIDTH = 440;

export const pagerBeside = (viewport, doc) => !!doc && doc.pages.length > 1 && viewport.width >= PAGER_BESIDE_MIN_WIDTH;

export function fitScale(viewport, doc) {
  if (!viewport.width || !viewport.height || !doc) return 0;
  const sides = pagerBeside(viewport, doc) ? PAD.pager : PAD.x;
  return Math.max(0.05, Math.min((viewport.width - sides * 2) / doc.width, (viewport.height - PAD.top - PAD.bottom) / doc.height));
}
export const nextZoom = (scale, direction) => (direction > 0 ? ZOOM_STEPS.find(step => step > scale + 0.001) || ZOOM_STEPS[ZOOM_STEPS.length - 1]
  : [...ZOOM_STEPS].reverse().find(step => step < scale - 0.001) || ZOOM_STEPS[0]);

export function pinchZoom(scale, deltaY, deltaMode = 0) {
  const delta = Math.max(-PINCH_MAX_DELTA, Math.min(PINCH_MAX_DELTA, deltaY * (deltaMode === 1 ? 16 : 1)));
  return Math.max(ZOOM_RANGE[0], Math.min(ZOOM_RANGE[1], scale * Math.exp(-delta * PINCH_RATE)));
}
